import { useState } from 'react'
import { SlideOver, Button, TagLabel } from '../ds/index.js'
import { AboutCard, RecordTimeline } from './RecordPage.jsx'
import { tsToDate } from '../lib/format.js'

const RECENT_LIMIT = 5

/**
 * HubSpot-style peek: a right-drawer summary of a CRM record with inline-editable
 * key properties, recent activity, and quick actions (View record / Delete).
 * Presentational — the container supplies live data + handlers. See
 * docs/superpowers/specs/2026-07-15-record-peek-panel-design.md.
 */
export default function RecordPeek({
  objectChip, title, defs = [], record = {}, activities = [],
  users = [], usersById = {}, onChangeField, onViewRecord, onDelete, onClose,
}) {
  const [confirmDelete, setConfirmDelete] = useState(false)
  const noun = objectChip.toLowerCase()
  const recent = [...activities]
    .sort((a, b) => (tsToDate(b.createdAt)?.getTime() || 0) - (tsToDate(a.createdAt)?.getTime() || 0))
    .slice(0, RECENT_LIMIT)

  const footer = (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <Button variant="danger" size="sm" onClick={() => setConfirmDelete(true)}>Delete</Button>
      <Button size="sm" onClick={onViewRecord}>View record</Button>
    </div>
  )

  return (
    <SlideOver onClose={onClose} chip={<TagLabel>{objectChip}</TagLabel>} title={title} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {confirmDelete && (
          <div style={{ border: '1px solid var(--color-danger)', borderRadius: 'var(--radius-lg)', padding: 16 }}>
            <div style={{ fontSize: 13, color: 'var(--color-white)', marginBottom: 8 }}>Delete this {noun}?</div>
            <div style={{ fontSize: 12.5, color: 'var(--color-muted)', marginBottom: 12 }}>
              Linked records will be unlinked and timeline entries deleted. This can’t be undone.
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={() => setConfirmDelete(false)} className="btn btn-ghost" style={{ fontSize: 12, padding: '7px 12px' }}>Cancel</button>
              <Button variant="danger" size="sm" onClick={onDelete}>Delete {noun}</Button>
            </div>
          </div>
        )}
        <AboutCard defs={defs} record={record} users={users} onChange={onChangeField} />
        <div>
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            <span className="tag-label" style={{ color: 'var(--color-gold)' }}>Recent activity</span>
          </div>
          <RecordTimeline activities={recent} usersById={usersById} composer={null} />
        </div>
      </div>
    </SlideOver>
  )
}
